import { render, staticRenderFns } from "./FornecedorNovaExtensao.vue?vue&type=template&id=1438e49b"
import script from "./FornecedorNovaExtensao.vue?vue&type=script&lang=js"
export * from "./FornecedorNovaExtensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports